import { AxiosResponse } from 'axios';
import { t } from 'i18next';
import React from 'react'
import { useTkalDataContext } from '../../../context/tkalData';
import { OzonatorPurchaseOrder, OzonatorPurchaseOrderRow } from '../../../types/directo/OzonatorPurchaseOrder';
import { getOzonatorPurchaseOrder, getSavedOzonatorTests, getOzonatorTest, deleteOzonatorTest, GetSavedControlPanelTests, GetControlPanelTest, DeleteControlPanelTest } from '../../queries/testQueries';
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import ClearIcon from '@mui/icons-material/Clear';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Label } from 'reactstrap';
import { IconButton } from '@mui/material';
import OzonatorTestCategory from '../ozonator/common/OzonatorTestCategory';
import SelectTestType from '../../common/SelectTestType';
import { ControlPanelTestType } from '../../../types/control-panel/ControlPanelTest';
import PrinterModal from '../../common/PrinterModal';
import { printProductCode } from '../../queries/adminQueries';
import { handleOpenWebsite } from '../CommonFunctions';

const SelectControlPanel = () => {
    const { setOzItemData, setItemNumber, itemNumber, setIsLoading, orderNumber, setOrderNumber, isLoading, setTestType, ozOrderData, setOzOrderData, controlPanelTest, setControlPanelTest, setSavedControlPanelTests, savedControlPanelTests } = useTkalDataContext();

    const handleGetOrderData = async (e: any) => {
        e.preventDefault();
        setIsLoading(true);
        if (!orderNumber) return alert(t("SalesorderNumberAlert"));
        getOzonatorPurchaseOrder(orderNumber, "controlPanel").then((res: AxiosResponse<OzonatorPurchaseOrder>) => {
            setOzOrderData(res.data);
            setControlPanelTest({ ...controlPanelTest, purchaseOrder: orderNumber })
        }).catch((err) => {
            if (err.response.status === 401 || err.response.status === 403) return alert("You dont have enough permissions to access this data")
            else {
                alert("Did not find any items");
                console.log(err.response.data)
            }
        }).finally(() => {
            setIsLoading(false);
        })
    }

    const handleItemRequest = async (item: OzonatorPurchaseOrderRow) => {
        setItemNumber(item.itemCode);
        setControlPanelTest({ ...controlPanelTest, productArticleNumber: item.itemCode, productUniqueId: item.id, productName: item.description, testType: 0 })
        /* setTestType(0); */
        setOzItemData(item)
        if (!orderNumber) return null;
        GetSavedControlPanelTests(orderNumber, item.id).then((res) => {
            setSavedControlPanelTests(res.data)
        }).catch(() => { }).finally(() => { })
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth', // This makes the scrolling smooth
        });
    }

    const handleTestType = (value: any) => {
        setControlPanelTest(prev => ({ ...prev, testType: value, id: 0 }))
    }

    function returnDate(dateString: string) {
        if (dateString === null) return;
        const year = dateString.substring(0, 4);
        const month = dateString.substring(5, 7);
        const day = dateString.substring(8, 10);
        return `${day}.${month}.${year}`
    }

    const handleLoadTestData = (id: number) => {
        setIsLoading(true)
        if (controlPanelTest.id === null) return;
        GetControlPanelTest(id).then((res) => {
            setControlPanelTest(res.data)
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const handleRemoveTest = (e: any, id: number) => {
        DeleteControlPanelTest(id).then(() => {
            setSavedControlPanelTests(prev => prev!.filter((item, _) => item.id !== id));
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            e.stopPropagation()
            setIsLoading(false)
        })
    }

    const isPrintingAllowed = (itemData: OzonatorPurchaseOrderRow) => {
        if (itemData?.testStatus === "Finished") return true;
        return false;
    }
    return (
        <div className="mainPageLayout">
            <div className="flexboxAlignedColumn mainPageForm" style={{ marginTop: "3%" }}>
                <form className="flexboxAlignedColumn mainPageForm" style={{ marginTop: "10%" }} onSubmit={e => handleGetOrderData(e ?? `${alert(t("ItemNotSelectedAlert"))}`)}>

                    <div className="flexboxAlignedColumn" style={{ padding: "2%" }}>
                        <Label className="mainPageForm-label">{t("InsertOrder")}</Label>
                        <div className="flexboxAlignedRow" style={{ gap: "5%" }}>
                            <input className="input-orderNr" type="number" onChange={e => setOrderNumber(e.target.value)} value={orderNumber ?? ""} placeholder={t("InsertNumber")} />
                            <Button className="button-primary" style={{ width: "94px" }} type="submit">{t("Search")}</Button>
                        </div>
                    </div>

                    {ozOrderData.items && (
                        <React.Fragment >
                            <Label className="mainPageForm-label" style={{ marginTop: "2%" }}>{t("Vali tooted")}</Label>
                            <div className="orderData">
                                {
                                    Object.values(ozOrderData.items).map((x, idx) => {
                                        return <div className='select-order-form__grid' key={idx}>
                                            <div>
                                                <PrinterModal item={x} isPrintingAllowed={isPrintingAllowed} printFunction={printProductCode} printFunctionArgs={[x.serialNumber]} defaultPrinter="OZ_Printer" printerLabeL={"OzProductCodeLabel"} />
                                            </div>
                                            <div className={`select-order-grid__label${(x.id === controlPanelTest.productUniqueId) ? " active" : ""}`}>
                                                <div className="itemData" onClick={() => handleItemRequest(x)}>{idx + 1}-{x.itemCode} {x.description} {x.serialNumber !== null && `SN:${x.serialNumber}`}</div>
                                            </div>
                                            <div className="select-order-grid__icon2"  >
                                                {x.testStatus === "Finished" ?
                                                    <IconButton title="Testi staatus">
                                                        <DoneIcon style={{ fill: "green" }} />
                                                    </IconButton> :
                                                    <IconButton title="Testi staatus">
                                                        <CloseIcon style={{ fill: '#FF0000' }} />
                                                    </IconButton>}
                                            </div>
                                        </div>
                                    })
                                }
                            </div>

                            {itemNumber &&
                                <SelectTestType
                                    handleTestType={handleTestType}
                                    testType={controlPanelTest.testType}
                                    enumType={ControlPanelTestType}
                                />
                            }

                            {savedControlPanelTests && savedControlPanelTests.length > 0 ? (
                                <div className="orderData" style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>

                                    {savedControlPanelTests.filter(x => x.testStatus === "Created").length > 0 &&
                                        <>
                                            <Label className="mainPageForm-label" style={{ marginTop: "5%" }}>{t("TestsInProgress")}</Label>
                                            {savedControlPanelTests.filter(x => x.testStatus === "Created").map((x, idx) =>
                                                <div key={idx} style={{ height: "100%", minHeight: "70px", width: "80%", display: "flex", justifyContent: "center" }}>
                                                    <div style={{ height: "100%", minHeight: "70px", display: "flex", justifyContent: "center" }} className={`orderDataOrders${x.id === controlPanelTest.id ? " active" : ""}`}
                                                        onClick={() => handleLoadTestData(x.id)}>{x.productName} - {t(`${x.testName}`)} - {x.createdBy} - {returnDate(x.createdDate.toString())}
                                                    </div>
                                                    <IconButton style={{ marginTop: "4%" }} onClick={(e: any) => handleRemoveTest(e, x.id!)}>
                                                        <ClearIcon />
                                                    </IconButton>
                                                </div>)}
                                        </>
                                    }
                                    {savedControlPanelTests.filter(x => x.testStatus === "Finished").length > 0 &&
                                        <>
                                            <Label className="mainPageForm-label" style={{ marginTop: "5%" }}>{t("TestsFinished")}</Label>
                                            {savedControlPanelTests.filter(x => x.testStatus === "Finished").map((x, idx) =>
                                                <div key={idx} style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", gap: "25px" }}>
                                                    <div key={idx} style={{ height: "100%", minHeight: "70px", width: "70%", display: "flex", justifyContent: "center" }} className={`orderDataOrders${x.id === controlPanelTest.id ? " active" : ""}`}
                                                        onClick={() => handleLoadTestData(x.id)}>{x.productName} - {t(`${x.testName}`)} - {x.createdBy} - {returnDate(x.createdDate.toString())}
                                                    </div>
                                                    <IconButton disabled={isLoading} style={{ marginTop: "4%", cursor: "pointer" }} onClick={() => handleOpenWebsite(x.directoCode)}>
                                                        <OpenInNewIcon />
                                                    </IconButton>
                                                </div>
                                            )}
                                        </>
                                    }
                                </div>
                            ) : null}
                        </React.Fragment>
                    )}
                </form>
            </div>
        </div>
    )
}

export default SelectControlPanel